<script setup lang="ts">
import { computed } from 'vue';
import { type RouteLocationRaw, RouterLink, type RouterLinkProps } from 'vue-router';

import { useMultiClusterStore } from '@/stores/multiCluster';

// TODO extend this component to handle <a> tags also

const props = withDefaults(
  defineProps<
    RouterLinkProps & {
      useProxy?: boolean;
    }
  >(),
  { useProxy: true },
);

const emit = defineEmits<{ click: [] }>();

const multiClusterStore = useMultiClusterStore();

const location = computed((): Exclude<RouteLocationRaw, string> => {
  if (typeof props.to === 'string') return { path: props.to };
  return props.to;
});
</script>

<template>
  <RouterLink
    v-bind="props"
    :to="{
      ...location,
      query: {
        cl: props.useProxy ? multiClusterStore.proxiedCluster : undefined,
        ...location.query,
      },
    }"
    @click="emit('click')"
  >
    <slot />
  </RouterLink>
</template>
